<template>
  <div>
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Nome Paciente</th>
          <th>Unidade</th>
          <th>Especialidade</th>
          <th>Data Agendamento</th>
          <th>Hora Agendamento</th>
          <th>Desativado em</th>
          <th>Desativado por</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="agendamento in agendamentos" :key="agendamento._id">
          <td>{{ agendamento.paciente.nome }}</td>
          <td>{{ agendamento.unidade }}</td>
          <td>{{ agendamento.especialidade }}</td>
          <td>{{ formatarData(agendamento.data, 'DD/MM/YYYY', true) }}</td>
          <td>{{ agendamento.hora }}</td>
          <td>{{
            formatarData(agendamento.updatedAt, 'DD/MM/YYYY HH:MM:ss', true)
          }}</td>
          <td>{{ agendamento.atualizadoPor }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import * as formatadores from '@/utils/formatadores'

export default {
  name: 'AgendamentosDesatualizadosTabela',
  props: {
    agendamentos: {
      type: Array,
      required: true,
    },
  },
  methods: {
    ...formatadores,
  },
}
</script>
